import * as React from "react";
import { iTableColumn } from "./interfaces";

export interface iProps {
  columns: iTableColumn[];
}

/**
 * Renders a table head.
 */
const TableHead: React.SFC<iProps> = (props: iProps) => {
  const cells: React.ReactNode[] = props.columns.map((col, index) => (
    <th className="table__cell" key={`cell.${col.key}`}>
      {col.label}
    </th>
  ));

  return (
    <thead className="table__head">
      <tr className="table__row">{cells}</tr>
    </thead>
  );
};

export default TableHead;
